import axios from 'axios'
import store from '@/store'
import router from '@/router'
import { ElMessage } from 'element-plus'

/**
 * 解析后端 API 基础地址。
 * Vue CLI / Webpack 会在编译期把 `process.env.VUE_APP_API_URL`
 * 静态替换为 `.env.development` 中配置的字符串字面量。
 */
function resolveApiBaseUrl() {
    const raw = process.env.VUE_APP_API_URL || ''
    const url = String(raw).trim().replace(/^["']|["']$/g, '')
    return url || 'http://localhost:8090'
}

const instance = axios.create({
    baseURL: resolveApiBaseUrl(),
    timeout: 10000
})

instance.interceptors.request.use(function (config) {
    const token = store.state.token
    if (token) {
        config.headers['Authorization'] = token
    }
    return config
}, function (error) {
    return Promise.reject(error)
})

instance.interceptors.response.use(function (response) {
    return response
}, function (error) {
    if (error.response) {
        const status = error.response.status
        if (status === 401) {
            ElMessage.error('登录已过期，请重新登录')
            store.dispatch('logout')
            router.push('/login')
        } else if (status === 403) {
            ElMessage.error('权限不足')
        } else {
            ElMessage.error(error.response.data?.message || '请求失败')
        }
    } else if (error.code === 'ECONNABORTED') {
        ElMessage.error('请求超时，请检查网络')
    } else {
        ElMessage.error('网络异常，请稍后重试')
    }
    return Promise.reject(error)
})

export default instance
